export default __webpack_public_path__ + "static/media/O-013.103b746d.png";